"use client";
import { useEffect } from "react";
import posthog from "posthog-js";

/**
 * Global, render-free listener. Every CTA on the site funnels to the same
 * Calendly popup, so a single listener captures the one real conversion event.
 */
export default function CalendlyAnalyticsListener() {
  useEffect(() => {
    const onMessage = (e: MessageEvent) => {
      if (e.data?.event === "calendly.event_scheduled") {
        posthog.capture("booking_scheduled");
      }
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return null;
}
